import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=33f99bb5&scoped=true"
import script from "./tab.ts?vue&type=script&lang=ts&external"
export * from "./tab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f99bb5",
  null
  
)

export default component.exports